import { render, staticRenderFns } from "./loginPopover.vue?vue&type=template&id=a6bf07c0&scoped=true"
import script from "./loginPopover.vue?vue&type=script&lang=js"
export * from "./loginPopover.vue?vue&type=script&lang=js"
import style0 from "./loginPopover.vue?vue&type=style&index=0&id=a6bf07c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf07c0",
  null
  
)

export default component.exports